<small *ngIf="displayError" class="error-text">
    {{ errorMsg }}
</small>
